// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION: any = {
  "branch": "master",
  "sha": "1814fc69290055ed0d1ce11486838fdca364b63a",
  "abbreviatedSha": "1814fc692",
  "tag": "2026.11.5",
  "lastTag": "2026.11.5",
  "commitsSinceLastTag": 0,
  "version": "2026.11.5",
  "commitCount": 13944
};
/* eslint-enable */
